import { useEffect } from "react";
import { FaWallet } from "react-icons/fa";

export default function GooglePayButton({
  amount,
  onPaymentSuccess,
  onPaymentError,
  disabled = false,
}) {
  // Load Razorpay checkout script
  const loadRazorpayScript = () =>
    new Promise((resolve, reject) => {
      if (document.getElementById("razorpay-script")) {
        // Script already loaded
        resolve();
        return;
      }
      const script = document.createElement("script");
      script.id = "razorpay-script";
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = resolve;
      script.onerror = () => reject(new Error("Razorpay SDK failed to load"));
      document.body.appendChild(script);
    });

  const handlePayment = async () => {
    try {
      await loadRazorpayScript();

      const orderResponse = await fetch(
        `${process.env.REACT_APP_SERVER_BASE_URL}/payment/room-payment.php`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ amount }),
        }
      );

      if (!orderResponse.ok) {
        throw new Error(`Server responded with status ${orderResponse.status}`);
      }

      const orderData = await orderResponse.json();

      if (!orderData.success || !orderData.order_id || !orderData.amount) {
        throw new Error(orderData.message || "Failed to create order");
      }

      const options = {
        key: "rzp_test_VP4xV6zf0Jk68K", // Replace with your Razorpay Key ID (public key, NOT secret)
        amount: orderData.amount,
        currency: "INR", // Change to "INR" in production
        name: "Room Booking Penukonda Baba Fakrudin",
        description: "Pay using Google Pay",
        image: "", // Optional: add your logo URL if you want
        order_id: orderData.order_id,
        handler: function (response) {
          onPaymentSuccess(response);
        },
        prefill: {
          name: "Test User",
          email: "tas@example.com",
          contact: "84947917",
        },
        theme: {
          color: "#F37254",
        },
        method: {
          upi: true, // enable UPI apps (Google Pay, PhonePe, etc.)
          card: true, // enable card payments (recommended)
          netbanking: false,
          wallet: false,
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment error:", error);
      onPaymentError(error.message || "Something went wrong with payment");
    }
  };

  return (
    <button
      onClick={handlePayment}
      disabled={disabled}
      className={`bg-gray-900 border border-gray-300 shadow-sm flex items-center justify-center px-6 py-3 rounded-lg text-white font-semibold transition ${
        disabled ? "opacity-50 cursor-not-allowed" : "hover:shadow-lg"
      }`}
      type="button"
    >
      <FaWallet className="text-2xl mr-2" />
      Make Payment
    </button>
  );
}
